angular.module('dialogs')
    .controller('ReleaseTimeDialogCtrl',
        [
            '$scope', '$modalInstance', '$dialogs', '$routeParams', "EventFactory", "$route", "$timeout", "appInfoFactory", 'moment',
            function ($scope, $modalInstance, $dialogs, $routeParams, eventFactory, $route, $timeout, appInfoFactory, moment) {

                var sportcode = $("#sportcode").val();

                //function convertUtcDateToLocalDate(date) {
                //    var newDate = new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000);

                //    var offset = date.getTimezoneOffset() / 60;
                //    var hours = date.getHours();

                //    newDate.setHours(hours - offset);

                //    return newDate;
                //};

                function setReleaseTimeScope() {
                    var releaseTime = $("#event-release-time").text().trim();
                    if (releaseTime === "00:00:00") {
                        $scope.releasedTime = {
                            hours: "",
                            minutes: "",
                            seconds: ""
                        }
                    } else {
                        var releasedTimeAry = releaseTime.split(":");

                        $scope.releasedTime = {
                            hours: releasedTimeAry[0],
                            minutes: releasedTimeAry[1],
                            seconds: releasedTimeAry[2]
                        }
                    }
                }

                setReleaseTimeScope();

                $scope.Release = function () {
                    $modalInstance.dismiss('no');
                    var releasetime = $scope.releasedTime.hours +
                        ":" +
                        $scope.releasedTime.minutes +
                        ":" +
                        $scope.releasedTime.seconds;
                    var dialog;

                    appInfoFactory.getDateTime()
                        .success(function (dateTime) {
                            var today = new Date(JSON.parse(dateTime));
                            today.setHours($scope.releasedTime.hours);
                            today.setMinutes($scope.releasedTime.minutes);
                            today.setSeconds($scope.releasedTime.seconds);

                            var scheduled = new Date(Date.parse($("#hdnEventTime").val()));
                            scheduled.setMinutes(scheduled.getMinutes() + scheduled.getTimezoneOffset());

                            var scheduledTime = scheduled.getTime();
                            var actualTime = today.getTime();

                            if (actualTime < scheduledTime)
                                dialog = $dialogs.confirm('Please Confirm',
                                    'Are you sure you want to release this event at ' +
                                    releasetime +
                                    ', before the scheduled release time?');
                            else
                                dialog = $dialogs.confirm('Please Confirm',
                                    'Release Time ' + releasetime + ' Are you sure?');

                            dialog.result.then(function (btn) {

                                const releaseTimeDate = moment.tz(moment.tz.guess());
                                releaseTimeDate.set('hour', parseInt($scope.releasedTime.hours));
                                releaseTimeDate.set('minute', parseInt($scope.releasedTime.minutes));
                                releaseTimeDate.set('second', parseInt($scope.releasedTime.seconds));

                                //var date = new Date(1970,
                                //    00,
                                //    01,
                                //    $scope.releasedTime.hours,
                                //    $scope.releasedTime.minutes,
                                //    $scope.releasedTime.seconds);

                                debugger;
                                //var x = convertUtcDateToLocalDate(date);

                                //eventFactory.Release($routeParams.eventId, date.getTime())
                                eventFactory.Release($routeParams.eventId, releaseTimeDate.valueOf())
                                    .success(function (event) {
                                        $route.reload();
                                    })
                                    .error(function (error) {
                                        $.message(error.ExceptionMessage, MessageType.Error);
                                    });
                            });
                        })
                        .error(function (error) {
                            $.message(error.ExceptionMessage, MessageType.Error);
                        });
                };

                $scope.ResetReleaseTime = function () {
                    setReleaseTimeScope();
                    this.formScope.releasetimeForm.$setPristine();
                };

                $scope.no = function () {
                    $modalInstance.dismiss('no');
                };

                $scope.setFormScope = function (scope) {
                    this.formScope = scope;
                }
            }
        ]);